import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import store from './app/store/index'
import Layout from '@/app/components/Layout/Layout'
import SimuladorService from '@/app/services/Simulador/simulador.service'

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        { path: '/', redirect: 'principal' },
        { path: '/erro', name: 'Erro', component: require('@/app/views/Erro.vue').default, meta: { allow: 'everyone' }},
        { path: '/', component: Layout, children: [
            { path: '/principal', name: 'Principal', component: require('@/app/views/Principal.vue').default, async beforeEnter(to, from, next) {
                if (!to.query.token) { // Não existe token na url. Gerar um e inseri-lo na url
                    let resposta = await SimuladorService.obterTokenCarteira();

                    if (resposta.sucesso) {
                        store.commit("setCarteiraAtualSalva", false);
                        router.push({ path: 'principal', query: { token: resposta.token }})
                        // next();
                    }
                } else { // Token foi informado, verificar se ele é válido
                    let resposta = await SimuladorService.validarTokenCarteira(to.query.token);

                    if (resposta.sucesso) {
                        next();
                    } else { // Token inválido; gerar outro
                        resposta = await SimuladorService.obterTokenCarteira();
                        
                        if (resposta.sucesso) {
                            store.commit("setCarteiraAtualSalva", false);
                            router.push({ path: 'principal', query: { token: resposta.token }})
                            // next();
                        }
                    }
                }
            } },
            { path: '/relatorio', component: require('@/app/views/Relatorio.vue').default },
        ]}
    ]
})

router.afterEach((to) => {
    document.title = "Simulador de investimentos | C6 Bank";
});

export default router;